<template>
    <div class="container">
        <vue-headful :title="'Sign Up:: MeritEHS'"></vue-headful>

        <div class="row align-items-center">
            <div class="col-lg-8 offset-lg-2 col-md-10 offset-md-1 row">
                <div class="col-6 offset-3 text-center mt-5 mb-3" style="max-width: 100%">
                    <img src="/Images/Merit-EHS.png" style="max-width: 100%">
                </div>
                <div class="card" v-show="!sign_up_type" style="width: 100%">
                    <div class="card-body">
                        <h4 class="mt-4 mb-4 text-center">Choose Your Sign Up Process</h4>
                        <div class="row mt-4">
                            <div class="col-md-6 mb-md-0 mb-3 text-center">
                                <button type="button" class="btn btn-default" v-on:click="sign_up_type = 'graph'" :disabled="redirecting">
                                    <img src="/Images/office365.png" /> Sign Up with Office 365
                                </button>
                            </div>
                            <div class="col-md-6 text-center">
                                <button type="button" class="btn btn-default" v-on:click="sign_up_type = 'basic'" :disabled="redirecting">
                                    <img src="/Images/email-icon.png" class="mr-2" /> Sign Up with Email/Password
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-show="sign_up_type == 'basic'" style="width: 100%">
                    <div class="card-body">
                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.ClientName}">Company:</label>
                            <div class="col-sm-8">

                                <b-form-input type="text" v-model="account.ClientName" :class="{'is-invalid': errors.ClientName}" placeholder="Enter Your Company Name"></b-form-input>

                                <span v-if="errors.ClientName" class="text-danger">
                                    <span v-for="error in errors.ClientName">{{ error }}</span>
                                </span>

                                <span v-if="errors.account_domain" class="text-danger">
                                    <span v-for="error in errors.account_domain">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <hr/>

                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.FirstName}">First Name:</label>
                            <div class="col-sm-8">

                                <b-form-input type="text" v-model="account.FirstName" :class="{'is-invalid': errors.FirstName}" placeholder="Enter Your First Name"></b-form-input>

                                <span v-if="errors.FirstName" class="text-danger">
                                    <span v-for="error in errors.FirstName">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.LastName}">Last Name:</label>
                            <div class="col-sm-8">

                                <b-form-input type="text" v-model="account.LastName" :class="{'is-invalid': errors.LastName}" placeholder="Enter Your Last Name"></b-form-input>

                                <span v-if="errors.LastName" class="text-danger">
                                    <span v-for="error in errors.LastName">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.username}">Email:</label>
                            <div class="col-sm-8">

                                <b-form-input type="email" v-model="account.username" :class="{'is-invalid': errors.username}" placeholder="Enter Your Email Address. This will be your username"></b-form-input>

                                <span v-if="errors.username" class="text-danger">
                                    <span v-for="error in errors.username">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <hr/>

                        <template v-if="!hidePassword">
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password}">Password:</label>
                                <div class="col-sm-8">

                                    <input type="password" v-model="account.password" placeholder="Minimum 8 Characters" :class="{'form-control': true, 'is-invalid': errors.password}" />

                                    <span v-if="errors.password" class="text-danger">
                                        <span v-for="error in errors.password">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password_confirmation}">Confirm Password:</label>
                                <div class="col-sm-8">

                                    <input type="password" v-model="account.password_confirmation" placeholder="Confirm your password" :class="{'form-control': true, 'is-invalid': errors.password_confirmation}" />

                                    <span v-if="errors.password_confirmation" class="text-danger">
                                        <span v-for="error in errors.password_confirmation">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr />
                        </template>

                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.promo_code}">Promo Code:</label>
                            <div class="col-sm-8">

                                <input v-model="account.promo_code" placeholder="Enter Promo Code" :class="{'form-control': true, 'is-invalid': errors.promo_code}" />

                                <span v-if="errors.promo_code" class="text-danger">
                                    <span v-for="error in errors.promo_code">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <hr />

                        <div class="form-group offset-sm-2">
                            <b-form-checkbox v-model="account.privacy" value="1" unchecked-value="0" plain>
                                I have read and understand the <a href="https://www.meritehs.com/privacy-policy">Privacy Policy.</a>
                            </b-form-checkbox>

                            <div v-if="errors.privacy" class="text-danger">
                                <span v-for="error in errors.privacy">{{ error }}</span>
                            </div>
                        </div>
                        <div class="form-group offset-sm-2">
                            <b-form-checkbox v-model="account.terms_and_use" value="1" unchecked-value="0" plain>
                                I agree to the <a href="https://www.meritehs.com/terms-of-use">Terms of Use.</a>
                            </b-form-checkbox>

                            <div v-if="errors.terms_and_use" class="text-danger">
                                <span v-for="error in errors.terms_and_use">{{ error }}</span>
                            </div>
                        </div>
                        <div class="col-sm-8 offset-sm-2">
                            <div class="g-recaptcha" :data-sitekey="recaptchaKey"></div>

                            <span v-if="errors['g-recaptcha-response']" class="text-danger">
                                <span v-for="error in errors['g-recaptcha-response']">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="card-footer">
                        <template v-if="saving">
                            <button type="button" class="btn btn-success disabled" :disabled="true">
                                Creating Your Account...
                            </button>
                        </template>
                        <template v-else>
                            <button type="button" class="btn btn-success mr-3" @click="signUp(false)">
                                Free Trial
                            </button>
                            <button type="button" class="btn btn-info mr-1" @click="signUp(true)">
                                Buy Now
                            </button>
                            <small>*includes free trial</small>

                            <a href="javascript:void(0)" class="pull-right" v-on:click="resetSignUp()">
                                Change Sign Up Process
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="spacer" style="height: 100px;"></div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                sign_up_type: null,
                redirecting: false,
                hidePassword: false,
                recaptchaKey: process.env.MIX_RECAPTCHA_SITE_KEY,
                // now: +new Date(),
                account: {},
                errors: {},
            }
        },

        watch: {
            sign_up_type(newVal, oldVal){
                //Check for Graph
                if(newVal !== 'graph')
                {
                    return;
                }

                //Send it
                this.sendToOffice();
            }
        },

        methods: {

            signUp(buy_now) {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Set the account value
                this.account['g-recaptcha-response'] = grecaptcha.getResponse();

                //Send it
                this.$http
                .postWeb('sign-up', this.account)
                .then(response => {
                    //Alert the user?
                    this.$store.commit('toast', {msg: 'Thanks for trying us out! We\'ll get in touch with you soon to see if you have any questions or need assistance.', title: 'Account Created', timeOut: 15000, closeOnHover: false})

                    //Return to main list?
                    if (buy_now)
                    {
                        // this.$router.push('/billing', () => {
                        //     this.$router.go();
                        // });
                        window.location = '/billing?setup=true';
                    }
                    else
                    {
                        // this.$router.push('/', () => {
                        //     this.$router.go();
                        // });
                        //window.location = '/';
                        window.location = '/admin/setup-wizard';
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }

                    //Reset
                    grecaptcha.reset();
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            resetSignUp(){
                //Set it
                this.sign_up_type = null;
                this.login_type = null;

                //Reset the User
                this.account = {};
            },

            sendToOffice(){
                //SHow loading
                this.redirecting = true;

                //Send it
                this.$http
                .postWeb('sign-up/graph', this.account)
                .then(response => {
                    //Send them to the SSO Endpoint
                    window.location = response.data;
                    //console.log(response.data);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }

                    //Reset
                    grecaptcha.reset();
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            // this.account = {
                // ClientName: this.now,
                // FirstName: this.now,
                // LastName: this.now,
                // username: this.now+'@'+(this.now)+'.com',
                // password: this.now,
                // password_confirmation: this.now,
                // privacy: 1,
                // terms_and_use: 1,
            // }
            // //Load the stripe script
            let recaptcha = document.createElement('script');
            recaptcha.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
            //recaptcha.async = true;
            //recaptcha.defer = true;

            //Append the script
            document.head.appendChild(recaptcha);

            // //Now call the helper?
            // this.loadRecaptcha();

            //Get the Clients
            //this.loadResources();
        },

        created() {
            //Set the values
            if(this.$route.query.login_type)
            {
                //Hide Password
                this.hidePassword = true;

                //Set the Sign Up type
                this.sign_up_type = 'basic';

                //Fill the values
                this.account.FirstName = this.$route.query.FirstName;
                this.account.LastName = this.$route.query.LastName;
                this.account.username = this.$route.query.email;
                this.account.ClientName = this.$route.query.ClientName;
                this.account.login_type = this.$route.query.login_type;
                this.account.account_domain = this.$route.query.account_domain;
                //this.account.privacy = '1';
                //this.account.terms_and_use = '1';

                //Send it
                //this.signUp();
            }
        }
    }
</script>
